import { useEffect, useState } from "react";
import {
  Clock,
  Today,
  RoundArrowCircle,
  Clander,
  TeamAvailability,
} from "../../../../component/LeadsDashboardComponents/StatCardIcons";
import {
  StatCard,
  StatsCardSkeleton,
} from "../../../../component/LeadsDashboardComponents/StatCard";

import { useApiCall } from "../../../../component/custom-hooks/api-call";

import { CircleAlert, IdCard, UserCheck } from "lucide-react";

import { TodayFollowups } from "../../../../component/LeadsDashboardComponents/TodayFollowUps";
import momentZone from "moment-timezone";

import AccountConversion from "../../../../component/AccountDashboardComponents/AccountConversion";
import { RecentAccountsTable } from "../../../../component/AccountDashboardComponents/RecentAccountsTable";

import AreaLineChart from "../../../../component/DealsDashboardComponents/AreaLineChart";
import { ChartMainCard } from "../../../../component/LeadsDashboardComponents/ChartsHeader";
import { Legend } from "highcharts";
import ServiceBarChart from "../../../../component/DealsDashboardComponents/ServiceBarChart";
import InnerLoader from "../../../../component/ui/loader/inner-loader";
import DateTime from "../../../../component/DateTime";

const View = "myaccounts";

export default function AccountsOrgOverviewNew() {
  // const [dateRange] = useState('11/02/2026 - 11/02/2026');
  const [brandFilter, setBrandFilter] = useState("this_month");

  const apiCall = useApiCall();

  const [overAllData, setOverAllData] = useState({});
  const [overAllLoading, setOverAllLoading] = useState(true);

  const getOverallData = async () => {
    setOverAllLoading(true);
    try {
      const resp = await apiCall({
        method: "get",
        url: `accounts/accounts-overview-kpi?view=${View}&time=${brandFilter}`,
      });
      setOverAllData(resp?.data);
      setOverAllLoading(false);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const [followUpsData, setfollowUpsData] = useState([]);
  const [followUpsApiLoading, setFollowUpsApiLoading] = useState(false);

  const getFollowUpsData = async () => {
    setFollowUpsApiLoading(true);
    try {
      const resp = await apiCall({
        method: "get",
        url: `activities/get-dashboard-followups?view=${View}&time=${brandFilter}`,
      });
      setfollowUpsData(resp?.data);
      setFollowUpsApiLoading(false);
    } catch (error) {
      setFollowUpsApiLoading(false);
      console.warn("Error : ", error);
    } finally {
      setFollowUpsApiLoading(false);
    }
  };

  useEffect(() => {
    getFollowUpsData();
    getOverallData();
  }, [brandFilter]);

  const chartData = {
    categories: overAllData?.revenue_trend?.data?.map((list) => list?.month),

    data: [
      {
        name: "Total Amount",
        color: "#5e6ceb",
        data: overAllData?.revenue_trend?.data?.map((d) =>
          Number(d?.total_amount?.replaceAll("$", "")?.replaceAll(",", "")),
        ),

        fillColor: {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
          stops: [
            [0, "rgba(59,130,246,0.25)"],
            [1, "rgba(59,130,246,0.02)"],
          ],
        },
      },

      // {
      //   name: "Won Deals",
      //   color: "#10B981",
      //   data:
      //     overAllData?.last_12_months_by_status_won_loss?.map(
      //       (d) => d?.won_deal
      //     ),

      //   fillColor: {
      //     linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
      //     stops: [
      //       [0, "rgba(16,185,129,0.25)"],
      //       [1, "rgba(16,185,129,0.02)"],
      //     ],
      //   },
      // },

      // {
      //   name: "Lost Deals",
      //   color: "#EF4444",
      //   data:
      //     overAllData?.last_12_months_by_status_won_loss?.map(
      //       (d) => d?.lost_deal
      //     ),

      //   fillColor: {
      //     linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
      //     stops: [
      //       [0, "rgba(239,68,68,0.25)"],
      //       [1, "rgba(239,68,68,0.02)"],
      //     ],
      //   },
      // },
    ],
  };

  return (
    <div className="w-full h-full overflow-auto p-5 flex flex-col">
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-3 gap-4">
        <div>
          <h1 className="text-[24px] font-bold">Account Metrics</h1>
        </div>
        <DateTime />
      </div>

      <div>
        <div
          className={`inline-flex items-center gap-1 py-2 px-[18px] rounded-[10px] text-sm font-medium mb-7 transition-all text-[#ff6347] border bg-[rgba(255,99,71,0.15)] border-[rgba(255,99,71,0.3)]`}
        >
          <CircleAlert className="w-[20px] h-[20px]" />
          You have {followUpsData?.overdue_followups} Overdue follow-ups from yesterday.
        </div>
      </div>

      <div className="h-full w-full">
        {/* Header */}
        <div className="mb-6">
          {/* Stat Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-6 gap-6">
            {!overAllLoading ? (
              <>
                <StatCard
                  icon={Clock}
                  iconBgColor="#BBF7D0"
                  iconColor={"#16A34A"}
                  title="Total Accounts"
                  value={overAllData?.total_accounts}
                  progress={40}
                  progressColor="bg-[#84CC16]"
                  subLabel="All Time Count"
                />
                <StatCard
                  icon={Today}
                  iconColor={"#FF7F50"}
                  iconBgColor="#FFEBE0"
                  title="Active Projects"
                  value={overAllData?.active_projects?.count}
                  progress={overAllData?.active_projects?.progress}
                  progressColor="bg-[#0095FF]"
                  trend={`${overAllData?.active_projects?.percentage}`}
                  trendUp={overAllData?.active_projects?.trendup}
                  subLabel="This Month"
                />
                <StatCard
                  icon={Clander}
                  iconColor={"#FF7F50"}
                  iconBgColor="#FFEBE0"
                  title="Active Clients"
                  value={overAllData?.active_clients?.count}
                  progress={overAllData?.active_clients?.progress}
                  progressColor="bg-[#0095FF]"
                  trend={`${overAllData?.active_clients?.percentage}`}
                  trendUp={overAllData?.active_clients?.trendup}
                  subLabel="This Month"
                />
                <StatCard
                  icon={RoundArrowCircle}
                  iconColor={"#FF4040"}
                  iconBgColor="#FEE2E2"
                  title="Pending Amount"
                  value={`${overAllData?.pending_amount?.count}`}
                  progress={overAllData?.pending_amount?.progress}
                  progressColor="bg-[#BF83FF]"
                  trend={overAllData?.pending_amount?.percentage}
                  trendUp={overAllData?.pending_amount?.trendup}
                  subLabel="Last 30 days"
                />

                <StatCard
                  icon={Clander}
                  iconColor={"#335CFF"}
                  iconBgColor="#DBEAFE"
                  title="Overdue Payments"
                  value={`${overAllData?.overdue_payments?.count}`}
                  progress={overAllData?.overdue_payments?.progress}
                  progressColor="bg-[#FF7F50]"
                  trend={overAllData?.overdue_payments?.percentage}
                  trendUp={overAllData?.overdue_payments?.trendup}
                  subLabel="Last 30 days"
                />

                <StatCard
                  icon={IdCard}
                  iconColor={"#FF4040"}
                  iconBgColor="#FEE2E2"
                  title="Revenue"
                  value={`${overAllData?.revenue?.count}`}
                  progress={overAllData?.revenue?.progress}
                  progressColor="bg-[#BF83FF]"
                  trend={overAllData?.revenue?.percentage}
                  trendUp={overAllData?.revenue?.trendup}
                // subLabel="4 overdue from yesterday"
                />
                {/* <StatCard
                  icon={IdCard}
                  iconColor={"#FF4040"}
                  iconBgColor="#FEE2E2"
                  title="Today Follow ups"
                  value={`4`}
                  progress={40}
                  progressColor="bg-[#BF83FF]"
                  subLabel="4 overdue from yesterday"
                /> */}
              </>
            ) : (
              Array.from({ length: 6 }).map((_, index) => <StatsCardSkeleton />)
            )}
          </div>
        </div>

        <div className="grid grid-cols-1 xl:grid-cols-12 gap-6 mb-6">
          <div className="xl:col-span-8 min-h-[410px]">
            {/* <AccountByProduct
              apiData={overAllData?.product_revenue?.data}
              apiLoading={overAllLoading}
            /> */}

            <ChartMainCard
              Icon={<TeamAvailability />}
              iconColor={"bg-[#DBEAFE] text-[#335CFF]"}
              heading="Revenue Trends"
              subHeading={"Account Revenue Trend"}
            >
              <div className="flex justify-start items-center gap-2 p-1 ml-[20px]">
                <div className="flex flex-col gap-[2px]">
                  <div className="text-[10px] font-semibold uppercase tracking-[0.7px] text-[#8a8f9e] mb-[3px]">
                    Best Month
                  </div>
                  <div className="text-[18px] font-extrabold text-[#22c55e]">
                    {overAllData?.revenue_trend?.best_amount}
                  </div>
                  <div className="text-[10px] text-[#8a8f9e] mt-[2px] capitalize">
                    {overAllData?.revenue_trend?.best_month}
                  </div>
                </div>

                <div className="flex flex-col gap-[2px]">
                  <div className="text-[10px] font-semibold uppercase tracking-[0.7px] text-[#8a8f9e] mb-[3px]">
                    Avg Month
                  </div>
                  <div className="text-[18px] font-extrabold text-[#000]">
                    {overAllData?.revenue_trend?.monthly_avg}
                  </div>
                  <div className="text-[10px] text-[#8a8f9e] mt-[2px] capitalize">
                    last 6 months
                  </div>
                </div>
              </div>

              {!overAllLoading ? (
                <AreaLineChart
                  chartData={chartData}
                  apiLoading={overAllLoading}
                  isMultiLines={false}
                />
              ) : null}
            </ChartMainCard>
          </div>

          <div className="xl:col-span-4 min-h-[410px]">
            <TodayFollowups
              view={View}
              loading={followUpsApiLoading}
              leads={followUpsData?.todays_followup_list}
              count={followUpsData?.todays_followup_count}
            />
          </div>
        </div>

        {/* Second Row */}
        <div className="grid grid-cols-1 xl:grid-cols-12 gap-6 mb-6">
          {/* <AccountConversion
              apiData={overAllData?.revenue_trend?.data}
              apiLoading={overAllLoading}
            /> */}



          <div className="xl:col-span-8 min-h-[410px]">
            <RecentAccountsTable
              apiData={overAllData?.recent_accounts}
              apiLoading={overAllLoading}
            />
          </div>

           <div className="xl:col-span-4 min-h-[410px] ">
            <ChartMainCard
              Icon={<TeamAvailability />}
              iconColor={"bg-theme-purple-light text-theme-purple"}
              heading="Revenue By Product"
              subHeading={"Collection This Month"}
            >
              {!overAllLoading ? (
                <>
                  <ServiceBarChart
                    chartData={overAllData?.product_revenue}
                    apiLoading={overAllLoading}
                  />
                  <div class="mt-3 p-4">
                    <div class="mb-[5px] flex items-center justify-between text-[11px] font-semibold text-gray-500">
                      <span>Payment Collection Rate</span>
                      <span class="text-blue-500">
                        {overAllData?.product_revenue?.collection_rate}
                      </span>
                    </div>

                    <div class="h-[7px] overflow-hidden rounded-[4px] bg-[#e8ecff]">
                      <div
                        class="h-full rounded-[4px] bg-[linear-gradient(90deg,#6366f1,#8b5cf6)] transition-all duration-[1500ms] ease-in-out"
                        style={{
                          width: overAllData?.product_revenue?.collection_rate,
                        }}
                      ></div>
                    </div>

                    <div class="mt-[5px] text-[11px] text-gray-500">
                      {overAllData?.product_revenue?.collected_amount} collected
                      of {overAllData?.product_revenue?.expected_amount} billed
                      ·
                      {/* Target 90% ·
                  <b class="text-green-600">+4% vs last month</b> */}
                    </div>
                  </div>
                </>
              ) : (
                <div className="h-full flex justify-center items-center">
                  <InnerLoader />
                </div>
              )}
            </ChartMainCard>
          </div>
        </div>
      </div>
    </div>
  );
}
